import md5 from "blueimp-md5";
import axios from "axios";
/*test.ts*/
// import { test1, test2, Test } from "./test.js";

/**
 * 设置页面标题
 * @param title
 */
export function setPageTitle(title: string) {
  document.title = title;
  //   if (isJiHE() && window.__appDelegate) {
  //     window.__appDelegate.callAction(
  //       JSON.stringify({
  //         type: 7,
  //         title
  //       })
  //     );
  //   }
}

/**
 * 手机号码隐藏中间四位
 */
export function formatMobileToPrivacy(mobile: string) {
  return mobile.substring(0, 3) + "****" + mobile.substr(mobile.length - 4);
}

/** 判断是否是微信浏览器 */
export function isWechat() {
  const ua = window.navigator.userAgent.toLowerCase();
  const matchResult = ua.match(/MicroMessenger/i);

  if (matchResult && matchResult.indexOf("micromessenger") > -1) {
    return true;
  } else {
    return false;
  }
}

/**
 * 记录用户浏览的当前页面的前一个页面路由，不包含登录相关路由
 */
export function getLastUserRoute() {
  return sessionStorage.getItem("last_user_route") || "/";
}

export function setLastUserRoute(routeFullPath: string) {
  return sessionStorage.setItem("last_user_route", routeFullPath);
}

/** 微信分享 */

/** 又拍云配置 */
export const upyunConfig = {
  api: "//v0.api.upyun.com/",
  bucket: "weixue-hztbc",
  apiSecret: "tbQ8Z1aoYwu5Kitxxzet6Wzqv0s=",
  domain: "//res.eweixue.com"
};

/** 又拍云配置 */
export const jh_upyunConfig = {
  api: "//v0.api.upyun.com/",
  bucket: "product-jihe",
  apiSecret: "2Wjr72+Ka8To5/1WMuLb9BngCPA=",
  domain: "//img2019.jiheapp.com"
};

/** 又拍云上传 */
export async function uploadToUpyun(file: File, dirName = "img") {
  if (!file) return;

  const saveKey = `/${dirName}/{year}{mon}{day}/{filemd5}{.suffix}`;
  const url = upyunConfig.api + upyunConfig.bucket;

  let options = {
    bucket: upyunConfig.bucket,
    "save-key": saveKey,
    expiration: Math.floor(new Date().getTime() / 1000) + 86400
  };

  const policy = window.btoa(JSON.stringify(options));
  const signature = md5(policy + "&" + upyunConfig.apiSecret);

  const data = new FormData();
  data.append("policy", policy);
  data.append("signature", signature);
  data.append("file", file);

  const { data: info } = await axios({
    url,
    data,
    method: "post"
  });
  if (file.type.startsWith("video")) {
    Object.assign(info, {
      cover: info.url + "!/snapshot/point/00:00:01/format/png"
    });
  }

  return info;
}

/**
 * 格式化又拍云给的文件路径
 * @param url 默认文件路径
 * @param mode full: 带协议的完整路径 proxy: 走反向代理的路径 auto(默认): 自适应协议头的路径
 */
export function formatUpyunUrl(
  url: string,
  mode: "full" | "proxy" | "auto" = "auto"
) {
  if (mode === "full") {
    return `https:${upyunConfig.domain}${url}`;
  } else if (mode === "proxy") {
    if (url.indexOf("/thirdwx.qlogo.cn/") > -1) {
      return url.replace(/(https|http):\/\/thirdwx.qlogo.cn/, "/qlogo");
    }
    return `/res${url}`;
  } else {
    if (url) {
      if (url.indexOf("//") != -1) {
        // HTTP 自动转 HTTPS，避免混合内容
        return url.replace(/^http:\/\//, "https://");
      }
      return `https:${upyunConfig.domain}${url}`;
    } else {
      return url;
    }
  }
}
/**
 * 格式化又拍云给的文件路径
 * @param url 默认文件路径
 * @param mode full: 带协议的完整路径 proxy: 走反向代理的路径 auto(默认): 自适应协议头的路径
 */
export function jh_formatUpyunUrl(
  url: string,
  mode: "full" | "proxy" | "auto" = "auto"
) {
  if (mode === "full") {
    return `https:${upyunConfig.domain}${url}`;
  } else if (mode === "proxy") {
    if (url.indexOf("/thirdwx.qlogo.cn/") > -1) {
      return url.replace(/(https|http):\/\/thirdwx.qlogo.cn/, "/qlogo");
    }
    return `/res${url}`;
  } else {
    return `${jh_upyunConfig.domain}${url}`;
  }
}

export function formatAvatar(
  avatar: string,
  mode: "full" | "proxy" | "auto" = "auto"
) {
  if (!avatar) return "";
  if (
    (avatar.indexOf("http") === 0 &&
      !(mode === "proxy" && avatar.indexOf("/thirdwx.qlogo.cn/") > -1)) ||
    avatar.indexOf(upyunConfig.domain) === 0 ||
    avatar.indexOf("/res") === 0 ||
    avatar.indexOf("/qlogo") === 0
  )
    return avatar;
  return formatUpyunUrl(avatar, mode);
}

// 判断安卓
export function isAndroid() {
  var u = navigator.userAgent;
  return u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
}

export function isIOS() {
  return !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
}

/** 判断是否是集盒大学app的webview环境 */
export function isJiHE() {
  return window.navigator.userAgent.search(/JiHE-/) >= 0;
}

/** 获取分享者id */
export function getExpandCustomerID() {
  return localStorage.getItem("expand_customer_id") || "";
}

/** 记录分享者id */
export function setExpandCustomerID(id: string) {
  return localStorage.setItem("expand_customer_id", id);
}

/**
 * 格式化文件尺寸
 * 根据macOS的文件大小算法，进制为1000
 * @param size 文件尺寸（单位B）
 */
export function formatSize(size: number) {
  if (size >= 1000 * 1000) {
    return (size / 1000 / 1000).toFixed(1) + " MB";
  } else if (size >= 1000) {
    return Math.round(size / 1000) + " KB";
  } else {
    return size + " 字节";
  }
}

//时分秒倒计时
export function countTime(end: number) {
  //获取当前时间
  var date = new Date();
  var now = date.getTime();
  // //设置截止时间
  // var endDate = new Date("2016-10-22 23:23:23");
  // var end = endDate.getTime();
  //时间差
  var leftTime = (end - now) / 1000;

  //定义变量 d,h,m,s保存倒计时的时间

  var h, m, s;
  if (leftTime >= 0) {
    h =
      Math.floor(leftTime / 60 / 60) < 10
        ? "0" + Math.floor(leftTime / 60 / 60)
        : Math.floor(leftTime / 60 / 60);
    m =
      Math.floor((leftTime / 60) % 60) < 10
        ? "0" + Math.floor((leftTime / 60) % 60)
        : Math.floor((leftTime / 60) % 60);
    s =
      Math.floor(leftTime % 60) < 10
        ? "0" + Math.floor(leftTime % 60)
        : Math.floor(leftTime % 60);
    return h + ":" + m + ":" + s;
  } else {
    return "00:00:00";
  }
  // console.log(h, m, s);
  // console.log(leftTime, "h");

  //递归每秒调用countTime方法，显示动态时间效果
  // eslint-disable-next-line
  // setTimeout(countTime, 1000);
}

/** 加载图片 */
export function loadImage(src: string) {
  return new Promise(resolve => {
    const image = new Image();
    image.onload = async () => {
      resolve(image);
    };
    image.src = src;
  });
}

// 获取元素位于文档中的绝对高度
export function GetPosition(obj: any) {
  var top = 0;
  while (obj != document.body) {
    top = obj.offsetTop;
    obj = obj.offsetParent;
  }
  return top;
}
//

// 获取时间 年月日
export function dateToStr(date: Date) {
  const year: any = date.getFullYear(); // 获取完整的年份(4位,1970-????)
  let month: any = date.getMonth() + 1; // 获取当前月份(0-11,0代表1月)
  let day: any = date.getDate(); // 获取当前日(1-31)
  if (month < 10) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + day;
  }
  const dateString = year + "年" + month + "月" + day + "日";
  return dateString;
}
// 数字转换英文月份
export function numToStrM(date: number) {
  let arr = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];
  console.log(arr[date]);
  return arr[date];
}

export function isProduction() {
  return process.env.VUE_APP_ENV === "production";
}

/**
 * 判断当前访问者是否为搜索引擎/AI 爬虫
 * 用于移动端跳转时排除爬虫，确保爬虫能正确抓取 PC 版内容
 */
export function isSearchBot() {
  const ua = navigator.userAgent || "";
  const botPatterns = [
    /Googlebot/i,
    /Baiduspider/i,
    /Bingbot/i,
    /Sogou/i,
    /360Spider/i,
    /HaosouSpider/i,
    /YandexBot/i,
    /DuckDuckBot/i,
    /Applebot/i,
    /Bytespider/i,
    /PetalBot/i,
    /Shenma/i,
    /CCBot/i,
    /GPTBot/i,
    /ClaudeBot/i,
    /anthropic-ai/i,
    /facebookexternalhit/i,
    /Twitterbot/i,
    /Slackbot/i,
    /LinkedInBot/i,
    /Pinterestbot/i,
    /Discordbot/i
  ];
  return botPatterns.some((pattern) => pattern.test(ua));
}

export function detectDeviceMobile() {
  // 搜索引擎/AI 爬虫不跳转移动端，确保抓取 PC 版完整内容
  if (isSearchBot()) {
    return false;
  }
  if (window.innerWidth <= 800 && /Mobi/i.test(navigator.userAgent)) {
    // 假设小于800px宽度且是移动设备用户代理的认为是移动端
    return true;
  } else {
    return false;
  }
}
